import shop from "@/router/asyncRoutes/merchant/shop";
import promotion from "@/router/asyncRoutes/merchant/promotion";
import salesman from "@/router/asyncRoutes/merchant/salesman";
import setting from "@/router/asyncRoutes/merchant/setting";

import capitalfund from "@/router/asyncRoutes/merchant/capitalfund";
import merchantSetting from "@/router/asyncRoutes/merchant/merchantSetting";

export default [shop, promotion, salesman, setting];
